<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Compare Drivers</span><br/>
      <span style="font-style: italic; font-size: 18px">compare active driver records across your {{ has_avatar ? 'Avatar, Telematics and Booking' : 'Telematics and Booking' }} platforms</span>
    </div>

    <div style="font-size: 22px; font-weight: bold; position: relative; margin: 30px" class="d-flex align-items-center justify-content-center">
      <b-button @click.prevent="load_missing_data()" size="lg" variant="success">Find Missing Drivers</b-button>
    </div>

    <!-- Only render the summary-dependent section if summary is loaded -->
    <div v-if="!loading && summary" style="text-align: left; margin:20px 20px 0px 20px; color: #666;">
      <div style="font-weight: bold; font-size: 24px;">
        Total Differences: {{ has_avatar
          ? countIncludedItems([summary.in_af_not_tbn, summary.in_af_not_telematics, summary.in_tbn_not_avatar, summary.in_tbn_not_telematics, summary.in_telematics_not_avatar, summary.in_telematics_not_tbn])
          : countIncludedItems([summary.in_tbn_not_telematics, summary.in_telematics_not_tbn]) }}
      </div>
      <hr/>

      <!-- Category: In Avatar Not TBN (only shown when Avatar is configured) -->
      <div v-if="has_avatar">
        <div style="display:flex; align-items:center;">
          <span style="color: var(--fi-rail-accent); font-weight: bold; font-size: 22px; cursor:pointer;" @click="toggle_div(toggle, 'in_af_not_tbn')">
            <b>A.</b> Drivers In Avatar & Missing From TBN - {{ countIncludedItems([summary.in_af_not_tbn]) }}
            <span v-if="countExcludedItems([summary.in_af_not_tbn])">
              (excluding {{ countExcludedItems([summary.in_af_not_tbn]) }})
            </span>
          </span>
          <div v-if="countExcludedItems([summary.in_af_not_tbn])" style="margin-left: 20px;">
            <b-button variant="success" @click.stop="toggleShowExcluded('in_af_not_tbn')">
              {{ showExcluded.in_af_not_tbn ? 'Hide Excluded' : 'Show Excluded' }}
            </b-button>
          </div>
          <div style="margin-left: 20px;">
            <b-button size="md" @click="saveChanges">Save</b-button>
          </div>
<!--          <div style="margin-left: 20px;">-->
<!--            <b-button variant="primary" @click="saveChanges" disabled>Add Drivers</b-button>-->
<!--          </div>-->
        </div>
        <br/>
        <div :style="toggle.in_af_not_tbn ? 'margin-left: 40px' : 'display:none'">
          <b-table
            :busy="loading"
            sticky-header="70vh"
            bordered
            :items="filteredList('in_af_not_tbn')"
            :fields="af_fields"
            primary-key="id"
            style="font-size:18px"
            :current-page="currentPage"
            :per-page="perPage">

            <template slot="norm_updated" slot-scope="row">
              {{ row.item.norm_updated | formatDateTimeSmall }}
            </template>
            <template slot="name" slot-scope="row">
              {{ row.item.fname }} {{ row.item.lname }}
            </template>
            <template slot="job" slot-scope="row">
              {{ row.item.job.name }} / {{ row.item.job.type }}
            </template>
            <template slot="compliance_info" slot-scope="row">
              <div><b>Start:</b> {{ row.item.compliance_info.compliance_start_on }}</div>
              <div><b>Do Not Dispatch:</b> {{ row.item.compliance_info.do_not_dispatch }}</div>
              <div><b>Is Compliant:</b> {{ row.item.compliance_info.is_compliant }}</div>
              <div><b>Is FMCSA Compliant:</b> {{ row.item.compliance_info.is_fmcsa_compliant }}</div>
            </template>
            <template slot="details" slot-scope="row">
              <b-button size="sm" @click="row.toggleDetails">
                {{ row.detailsShowing ? '-' : '+' }}
              </b-button>
            </template>
            <template slot="row-details" slot-scope="row">
              <b-card style="text-align: left;">
                <pre style="width: 800px; display: flex; flex-wrap: wrap">{{ row.item }}</pre>
              </b-card>
            </template>
            <template slot="exclude" slot-scope="row">
                <b-checkbox v-model="row.item.exclude" size="lg"></b-checkbox>
            </template>
            <template slot="compare_notes" slot-scope="row">
                <b-form-input v-model="row.item.compare_notes"/>
            </template>
            <template slot="actions" slot-scope="row">
              <b-button variant="primary" size="sm" @click="addDriverToTBN(row.item)" :disabled="!summary.data_services_compare_drivers_add_enabled">Add Driver</b-button>
            </template>
          </b-table>
          <b-row>
            <b-col>
              <b-pagination
                v-model="currentPage"
                :total-rows="filteredList('in_af_not_tbn').length"
                :per-page="perPage"
                align="center">
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
      <hr v-if="has_avatar"/>

      <!-- Category: In Avatar Not Telematics (only shown when Avatar is configured) -->
      <div v-if="has_avatar">
        <div style="display:flex; align-items:center;">
          <span style="color: var(--fi-rail-accent); font-weight: bold; font-size: 22px; cursor:pointer;" @click="toggle_div(toggle, 'in_af_not_telematics')">
            <b>B.</b> Drivers In Avatar & Missing From Samsara - {{ countIncludedItems([summary.in_af_not_telematics]) }}
            <span v-if="countExcludedItems([summary.in_af_not_telematics])">
              (excluding {{ countExcludedItems([summary.in_af_not_telematics]) }})
            </span>
          </span>
          <div v-if="countExcludedItems([summary.in_af_not_telematics])" style="margin-left: 20px;">
            <b-button variant="success" @click.stop="toggleShowExcluded('in_af_not_telematics')">
              {{ showExcluded.in_af_not_telematics ? 'Hide Excluded' : 'Show Excluded' }}
            </b-button>
          </div>
          <div style="margin-left: 20px;">
            <b-button size="md" @click="saveChanges">Save</b-button>
          </div>
<!--          <div style="margin-left: 20px;">-->
<!--            <b-button variant="primary" @click="saveChanges" disabled>Add Drivers</b-button>-->
<!--          </div>-->
        </div>
        <br/>
        <div :style="toggle.in_af_not_telematics ? 'margin-left: 40px' : 'display:none'">
          <b-table
            :busy="loading"
            sticky-header="70vh"
            bordered
            :items="filteredList('in_af_not_telematics')"
            :fields="af_fields"
            primary-key="id"
            style="font-size:18px"
            :current-page="currentPage"
            :per-page="perPage">
            <template slot="norm_updated" slot-scope="row">
              {{ row.item.norm_updated | formatDateTimeSmall }}
            </template>
            <template slot="name" slot-scope="row">
              {{ row.item.fname }} {{ row.item.lname }}
            </template>
            <template slot="job" slot-scope="row">
              {{ row.item.job.name }} / {{ row.item.job.type }}
            </template>
            <template slot="compliance_info" slot-scope="row">
              Start: {{ row.item.compliance_info.compliance_start_on }}
              <br/>Do Not Dispatch: {{ row.item.compliance_info.do_not_dispatch }}
              <br/>Is Compliant: {{ row.item.compliance_info.is_compliant }}
              <br/>Is FMCSA Compliant: {{ row.item.compliance_info.is_fmcsa_compliant }}
            </template>
            <template slot="details" slot-scope="row">
              <b-button size="sm" @click="row.toggleDetails">
                {{ row.detailsShowing ? '-' : '+' }}
              </b-button>
            </template>
            <template slot="row-details" slot-scope="row">
              <b-card style="text-align: left;">
                <pre style="width: 800px; display: flex; flex-wrap: wrap">{{ row.item }}</pre>
              </b-card>
            </template>
            <template slot="exclude" slot-scope="row">
                <b-checkbox v-model="row.item.exclude" size="lg"></b-checkbox>
            </template>
            <template slot="compare_notes" slot-scope="row">
                <b-form-input v-model="row.item.compare_notes"/>
            </template>
<!--            <template slot="actions" slot-scope="row">-->
<!--              <b-button variant="primary" size="sm" @click="saveChanges" disabled>Add Driver</b-button>-->
<!--            </template>-->
          </b-table>
          <b-row>
            <b-col>
              <b-pagination
                v-model="currentPage"
                :total-rows="filteredList('in_af_not_telematics').length"
                :per-page="perPage"
                align="center">
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
      <hr v-if="has_avatar"/>

      <!-- Category: In TBN Not Avatar (only shown when Avatar is configured) -->
      <div v-if="has_avatar">
        <div style="display:flex; align-items:center;">
          <span style="color: var(--fi-rail-accent); font-weight: bold; font-size: 22px; cursor:pointer;" @click="toggle_div(toggle, 'in_tbn_not_avatar')">
            <b>C.</b> Drivers In TBN & Missing From Avatar - {{ countIncludedItems([summary.in_tbn_not_avatar]) }}
            <span v-if="countExcludedItems([summary.in_tbn_not_avatar])">
              (excluding {{ countExcludedItems([summary.in_tbn_not_avatar]) }})
            </span>
          </span>
          <div v-if="countExcludedItems([summary.in_tbn_not_avatar])" style="margin-left: 20px;">
            <b-button variant="success" @click.stop="toggleShowExcluded('in_tbn_not_avatar')">
              {{ showExcluded.in_tbn_not_avatar ? 'Hide Excluded' : 'Show Excluded' }}
            </b-button>
          </div>
          <div style="margin-left: 20px;">
            <b-button size="md" @click="saveChanges">Save</b-button>
          </div>
        </div>
        <br/>
        <div :style="toggle.in_tbn_not_avatar ? 'margin-left: 40px' : 'display:none'">
          <b-table
            :busy="loading"
            sticky-header="70vh"
            bordered
            :items="filteredList('in_tbn_not_avatar')"
            :fields="tbn_fields"
            primary-key="id"
            style="font-size:18px"
            :current-page="currentPage"
            :per-page="perPage">
            <template slot="norm_updated" slot-scope="row">
              {{ row.item.norm_updated | formatDateTimeSmall }}
            </template>
            <template slot="details" slot-scope="row">
              <b-button size="sm" @click="row.toggleDetails">
                {{ row.detailsShowing ? '-' : '+' }}
              </b-button>
            </template>
            <template slot="row-details" slot-scope="row">
              <b-card style="text-align: left;">
                <pre style="width: 800px; display: flex; flex-wrap: wrap">{{ row.item }}</pre>
              </b-card>
            </template>
            <template slot="exclude" slot-scope="row">
                <b-checkbox v-model="row.item.exclude" size="lg"></b-checkbox>
            </template>
            <template slot="compare_notes" slot-scope="row">
                <b-form-input v-model="row.item.compare_notes"/>
            </template>
          </b-table>
          <b-row>
            <b-col>
              <b-pagination
                v-model="currentPage"
                :total-rows="filteredList('in_tbn_not_avatar').length"
                :per-page="perPage"
                align="center">
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
      <hr v-if="has_avatar"/>

      <!-- Category: In TBN Not Samsara -->
      <div>
        <div style="display:flex; align-items:center;">
          <span style="color: var(--fi-rail-accent); font-weight: bold; font-size: 22px; cursor:pointer;" @click="toggle_div(toggle, 'in_tbn_not_telematics')">
            <b>{{ has_avatar ? 'D' : 'A' }}.</b> Drivers In TBN & Missing From Samsara - {{ countIncludedItems([summary.in_tbn_not_telematics]) }}
            <span v-if="countExcludedItems([summary.in_tbn_not_telematics])">
              (excluding {{ countExcludedItems([summary.in_tbn_not_telematics]) }})
            </span>
          </span>
          <div v-if="countExcludedItems([summary.in_tbn_not_telematics])" style="margin-left: 20px;">
            <b-button variant="success" @click.stop="toggleShowExcluded('in_tbn_not_telematics')">
              {{ showExcluded.in_tbn_not_telematics ? 'Hide Excluded' : 'Show Excluded' }}
            </b-button>
          </div>
          <div style="margin-left: 20px;">
            <b-button size="md" @click="saveChanges">Save</b-button>
          </div>
        </div>
        <br/>
        <div :style="toggle.in_tbn_not_telematics ? 'margin-left: 40px' : 'display:none'">
          <b-table
            :busy="loading"
            sticky-header="70vh"
            bordered
            :items="filteredList('in_tbn_not_telematics')"
            :fields="tbn_fields"
            primary-key="id"
            style="font-size:18px"
            :current-page="currentPage"
            :per-page="perPage">
            <template slot="norm_updated" slot-scope="row">
              {{ row.item.norm_updated | formatDateTimeSmall }}
            </template>
            <template slot="details" slot-scope="row">
              <b-button size="sm" @click="row.toggleDetails">
                {{ row.detailsShowing ? '-' : '+' }}
              </b-button>
            </template>
            <template slot="row-details" slot-scope="row">
              <b-card style="text-align: left;">
                <pre style="width: 800px; display: flex; flex-wrap: wrap">{{ row.item }}</pre>
              </b-card>
            </template>
            <template slot="exclude" slot-scope="row">
                <b-checkbox v-model="row.item.exclude" size="lg"></b-checkbox>
            </template>
            <template slot="compare_notes" slot-scope="row">
                <b-form-input v-model="row.item.compare_compare_notes"/>
            </template>
          </b-table>
          <b-row>
            <b-col>
              <b-pagination
                v-model="currentPage"
                :total-rows="filteredList('in_tbn_not_telematics').length"
                :per-page="perPage"
                align="center">
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
      <hr/>

      <!-- Category: In Samsara Not Avatar (only shown when Avatar is configured) -->
      <div v-if="has_avatar">
        <div style="display:flex; align-items:center;">
          <span style="color: var(--fi-rail-accent); font-weight: bold; font-size: 22px; cursor:pointer;" @click="toggle_div(toggle, 'in_telematics_not_avatar')">
            <b>E.</b> Drivers In Samsara & Missing From Avatar - {{ countIncludedItems([summary.in_telematics_not_avatar]) }}
            <span v-if="countExcludedItems([summary.in_telematics_not_avatar])">
              (excluding {{ countExcludedItems([summary.in_telematics_not_avatar]) }})
            </span>
          </span>
          <div v-if="countExcludedItems([summary.in_telematics_not_avatar])" style="margin-left: 20px;">
            <b-button variant="success" @click.stop="toggleShowExcluded('in_telematics_not_avatar')">
              {{ showExcluded.in_telematics_not_avatar ? 'Hide Excluded' : 'Show Excluded' }}
            </b-button>
          </div>
          <div style="margin-left: 20px;">
            <b-button size="md" @click="saveChanges">Save</b-button>
          </div>
        </div>
        <br/>
        <div :style="toggle.in_telematics_not_avatar ? 'margin-left: 40px' : 'display:none'">
          <b-table
            :busy="loading"
            sticky-header="70vh"
            bordered
            :items="filteredList('in_telematics_not_avatar')"
            :fields="tm_fields"
            primary-key="id"
            style="font-size:18px"
            :current-page="currentPage"
            :per-page="perPage">
            <template slot="norm_updated" slot-scope="row">
              {{ row.item.norm_updated | formatDateTimeSmall }}
            </template>
            <template slot="details" slot-scope="row">
              <b-button size="sm" @click="row.toggleDetails">
                {{ row.detailsShowing ? '-' : '+' }}
              </b-button>
            </template>
            <template slot="row-details" slot-scope="row">
              <b-card style="text-align: left;">
                <pre style="width: 800px; display: flex; flex-wrap: wrap">{{ row.item }}</pre>
              </b-card>
            </template>
            <template slot="exclude" slot-scope="row">
                <b-checkbox v-model="row.item.exclude" size="lg"></b-checkbox>
            </template>
            <template slot="compare_notes" slot-scope="row">
                <b-form-input v-model="row.item.compare_notes"/>
            </template>
          </b-table>
          <b-row>
            <b-col>
              <b-pagination
                v-model="currentPage"
                :total-rows="filteredList('in_telematics_not_avatar').length"
                :per-page="perPage"
                align="center">
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
      <hr v-if="has_avatar"/>

      <!-- Category: In Samsara & Missing From TBN -->
      <div>
        <div style="display:flex; align-items:center;">
          <span style="color: var(--fi-rail-accent); font-weight: bold; font-size: 22px; cursor:pointer;" @click="toggle_div(toggle, 'in_telematics_not_tbn')">
            <b>{{ has_avatar ? 'F' : 'B' }}.</b> Drivers In Samsara & Missing From TBN - {{ countIncludedItems([summary.in_telematics_not_tbn]) }}
            <span v-if="countExcludedItems([summary.in_telematics_not_tbn])">
              (excluding {{ countExcludedItems([summary.in_telematics_not_tbn]) }})
            </span>
          </span>
          <div v-if="countExcludedItems([summary.in_telematics_not_tbn])" style="margin-left: 20px;">
            <b-button variant="success" @click.stop="toggleShowExcluded('in_telematics_not_tbn')">
              {{ showExcluded.in_telematics_not_tbn ? 'Hide Excluded' : 'Show Excluded' }}
            </b-button>
          </div>
          <div style="margin-left: 20px;">
            <b-button size="md" @click="saveChanges">Save</b-button>
          </div>
        </div>
        <br/>
        <div :style="toggle.in_telematics_not_tbn ? 'margin-left: 40px' : 'display:none'">
          <b-table
            :busy="loading"
            sticky-header="70vh"
            bordered
            :items="filteredList('in_telematics_not_tbn')"
            :fields="tm_fields"
            primary-key="id"
            style="font-size:18px"
            :current-page="currentPage"
            :per-page="perPage">
            <template slot="norm_updated" slot-scope="row">
              {{ row.item.norm_updated | formatDateTimeSmall }}
            </template>
            <template slot="details" slot-scope="row">
              <b-button size="sm" @click="row.toggleDetails">
                {{ row.detailsShowing ? '-' : '+' }}
              </b-button>
            </template>
            <template slot="row-details" slot-scope="row">
              <b-card style="text-align: left;">
                <pre style="width: 800px; display: flex; flex-wrap: wrap">{{ row.item }}</pre>
              </b-card>
            </template>
            <template slot="exclude" slot-scope="row">
                <b-checkbox v-model="row.item.exclude" size="lg"></b-checkbox>
            </template>
            <template slot="compare_notes" slot-scope="row">
                <b-form-input v-model="row.item.compare_notes"/>
            </template>
          </b-table>
          <b-row>
            <b-col>
              <b-pagination
                v-model="currentPage"
                :total-rows="filteredList('in_telematics_not_tbn').length"
                :per-page="perPage"
                align="center">
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <div v-else-if="loading">
      <b-spinner class="align-middle"></b-spinner>
    </div>
  </div>
</template>

<script>
import { tbn_get_compare_drivers_results, tbn_add_driver_to_tbn, tbn_save_driver_sync_mappings } from '../networking/tbn_apis'
import { mapState } from "vuex";
import moment from 'moment'

export default {
  name: 'compare_drivers',
  components: {},
  data() {
    return {
      toggle: {},
      showExcluded: {
        in_af_not_tbn: false,
        in_af_not_telematics: false,
        in_tbn_not_avatar: false,
        in_tbn_not_telematics: false,
        in_telematics_not_avatar: false,
        in_telematics_not_tbn: false,
      },
      has_avatar: true,
      driverExclusions: {},
      summary: null,
      loading: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
      fields_all: [],
      af_fields: [
        { key: 'details', label: '', sortable: false, thStyle: { width: "10px" } },
        { key: 'id', label: 'AF ID', sortable: true },
        { key: 'name', label: 'Driver', sortable: true },
        { key: 'employee_id', label: 'Employee ID', sortable: true },
        { key: 'norm_mobile', label: 'Phone #', sortable: true },
        { key: 'job', label: 'Job', sortable: true },
        { key: 'compliance_info', label: 'Compliance', sortable: true, thStyle: { width: "250px" }},
        { key: 'email', label: 'Email', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'norm_updated', label: 'Last Updated', sortable: true },
        { key: 'exclude', label: 'Exclude', sortable: true, thStyle: { width: "128px" } },
        { key: 'compare_notes', label: 'Notes', sortable: true, thStyle: { width: "250px" } },
        { key: 'actions', label: '', sortable: true },
      ],
      tbn_fields: [
        { key: 'details', label: '', sortable: false, thStyle: { width: "10px" } },
        { key: 'fullName', label: 'Driver', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'mobile_phone', label: 'Phone #', sortable: true },
        { key: 'primaryLocation', label: 'Location', sortable: true },
        { key: 'exclude', label: 'Exclude', sortable: true, thStyle: { width: "128px" } },
        { key: 'compare_notes', label: 'Note', sortable: true, thStyle: { width: "250px" } },
        { key: 'actions', label: '', sortable: true },
      ],
      tm_fields: [
        { key: 'details', label: '', sortable: false, thStyle: { width: "10px" } },
        { key: 'name', label: 'Driver', sortable: true },
        { key: 'phone', label: 'Phone #', sortable: true },
        { key: 'exclude', label: 'Exclude', sortable: true, thStyle: { width: "128px" } },
        { key: 'compare_notes', label: 'Note', sortable: true, thStyle: { width: "250px" } },
        { key: 'actions', label: '', sortable: true },
      ]
    }
  },
  async created() {
    this.fields_all = this.fields;
  },
  methods: {
    toggle_div(item, field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    // Toggle showing/hiding excluded rows for a category.
    toggleShowExcluded(category) {
      this.showExcluded[category] = !this.showExcluded[category];
    },
    filteredList(category) {
      if (!this.summary || !this.summary[category]) return [];
      return this.showExcluded[category]
          ? this.summary[category]
          : this.summary[category].filter(item => !item.exclude);
    },
    async load_missing_data() {
      this.loading = true;
      try {
        const {value: {data = []}} = await tbn_get_compare_drivers_results(this.user.tenant);
        this.summary = data;
        this.has_avatar = data.has_avatar !== false;
        if (this.summary.timezone) moment.tz.setDefault(this.summary.timezone);
      } catch (e) {
        this.$emit('showAlert', 'Error retrieving data, try logging in again or contact support if needed', 'danger', 5000);
      }
      this.loading = false;
    },
    async saveChanges() {
      try {
        this.$emit('showAlert', "Saving driver changes...", 'info');
        const payload = {
          in_tbn_not_telematics: this.summary.in_tbn_not_telematics,
          in_telematics_not_tbn: this.summary.in_telematics_not_tbn
        };
        if (this.has_avatar) {
          payload.in_af_not_tbn = this.summary.in_af_not_tbn;
          payload.in_af_not_telematics = this.summary.in_af_not_telematics;
          payload.in_tbn_not_avatar = this.summary.in_tbn_not_avatar;
          payload.in_telematics_not_avatar = this.summary.in_telematics_not_avatar;
        }
        const response = await tbn_save_driver_sync_mappings(this.user.tenant, payload);
        const message = (response && response.message) || 'Driver changes saved successfully!';
        this.$emit('showAlert', message, 'success', 1500);
      } catch (e) {
        this.$emit('showAlert', 'Error saving driver changes.', 'danger', 5000);
      }
    },
    async addDriverToTBN(record) {
      try {
        this.$emit('showAlert', "Adding driver to TBN", 'info');
        const response = await tbn_add_driver_to_tbn(this.user.tenant, record);
        const message = (response && response.message) || 'Driver added successfully!';
        this.$emit('showAlert', message, 'success', 1500);
      } catch (e) {
        this.$emit('showAlert', 'Error adding driver to TBN.', 'danger', 5000);
      }
    },
    toggleDriverExclusion(row) {
      this.$set(row.item, 'exclude', !row.item.exclude);
    }
  },
  computed: {
    ...mapState({
      user: state => state.profile.user
    }),
    countExcludedItems() {
      return (items_array) => {
        if (!Array.isArray(items_array)) {
          console.error('Expected an array, but got:', items_array);
          return 0;
        }
        return items_array.reduce((total, arr) => {
          return total + ((Array.isArray(arr) ? arr : [])).filter(item => item.exclude).length;
        }, 0);
      }
    },
    countIncludedItems() {
      return (items_array) => {
        if (!Array.isArray(items_array)) {
          console.error('Expected an array, but got:', items_array);
          return 0;
        }
        return items_array.reduce((total, arr) => {
          return total + ((Array.isArray(arr) ? arr : [])).filter(item => !item.exclude).length;
        }, 0);
      }
    }
  }
}
</script>

<style>
</style>
